const serviceAreas = {
  serviceAreas: {
    pageHeader: 'Servicegebieden',
    description:
      'Wanneer een huiseigenaar zoekt naar Enphase installateurs in een bepaald gebied, gebruiken we de %{regionOrCountyLabel} die u hier invoert om te controleren of u beschikbaar bent voor service in dat gebied of niet.',
    addNewArea: 'Nieuw gebied toevoegen',
    new: 'Nieuw',
    areaName: 'Gebiedsnaam',
    servicesCovered: {
      countiesCovered: 'Gedekte gemeentes',
      regionsCovered: "Gedekte regio's",
      provincesCovered: 'Provincies gedekt',
      regionsWithCount: '%{region}(Eerste twee cijfers van postcode)',
      districtsCovered: 'Districtdekking',
      citiesCovered: 'Gemeenten bestreken',
      citiesCoveredbr: 'Steden bestreken',
      departments: 'departementen',
      regions: "regio's",
      counties: 'gemeentes',
      districts: 'Districten',
      cities: 'gemeenten',
      provinces: 'Provincies',
      city: 'steden'
    },
    selectAllCounty: 'Selecteer alle %{regionOrCountyLabel} van een specifieke provincie',
    selectAllCountyWithRegion: 'Selecteer alle %{regionOrCountyLabel} Uit een bepaalde regio',
    selectAllDepartment: 'Alle departementen selecteren',
    addCountiesRegionsButton: 'Voeg %{regionOrCountyLabel} toe',
    countyButtonDescription:
      'Op basis van uw regio selectie worden alle gerelateerde %{regionOrCountyLabel} toegevoegd.',
    countyButtonDescriptionWithRegion: 'Op basis van uw Provincieselectie worden alle gerelateerde %{regionOrCountyLabel} toegevoegd.',
    area1: 'GEBIED 1',
    selectState: 'Selecteer provincies',
    selectRegion: 'Selecteer Regio',
    requestNotProcessed: 'Verzoek kon niet worden verwerkt',
    footerTitle:
      'Indicatieve prijzen zijn inclusief kosten voor installatie, rekken, PV-module, omvormer, enz. Kosten zoals dakbedekking, upgrade van het hoofdpaneel kunnen aanvullend zijn',
    footerBody:
      'Enphase zal deze indicatieve prijsstelling aan de huiseigenaar geven. Enphase zal een disclaimer aan de huiseigenaar geven dat deze prijzen onder voorbehoud zijn en onderhevig aan verandering.',
    noBlankRegions: 'Gedekte %{regionOrCountyLabel} kunnen niet blanco zijn',
    //noBlankCounties: 'Gemeenten die gedekt zijn, kunnen niet blanco zijn.',
    deleteConfirmation: 'Weet u zeker dat u dit servicegebied wilt verwijderen?',
    ok: 'Ok',
    infoText: `%{bTagOpen}%{regionOrCountyLabel}%{bTagClose} is gedefinieerd als de eerste %{count} getallen van een postcode in een %{stateOrProvince}.`,
    infoTextFr: `Departement is gedefinieerd als eerste 2 cijfers voor de postcode`,
    state: 'staat',
    province: 'provincie',
    noOptions: 'GeenOpties'
  }
};

export default serviceAreas;
